import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

import { ContentStatus } from "./knowledgeDb";

const { REQUIRED } = ERROR_TYPE;

export interface ObjectionCategory {
	id: number;
	name: string;
	isCustom: boolean;
}

export interface HandlingStrategy {
	id: number;
	strategyName: string;
	approach: string;
	exampleReply: string;
}

export interface Objection {
	id: number;
	categoryId: number;
	quote: string;
	underlyingConcern: string;
	strategies: HandlingStrategy[];
	status: ContentStatus;
	companyId: number;
	createdAt: string;
	updatedAt: string;
}

export const CreateObjectionSchema = z.object({
	categoryId: z.number({ error: REQUIRED }),
	quote: z.string().min(1, { message: REQUIRED }).trim(),
	underlyingConcern: z.string().min(1, { message: REQUIRED }).trim(),
	initialStrategyName: z.string().trim().optional().or(z.literal("")),
	initialApproach: z.string().trim().optional().or(z.literal("")),
	initialExampleReply: z.string().trim().optional().or(z.literal("")),
});

export type CreateObjection = z.infer<typeof CreateObjectionSchema>;

export const CreateCategorySchema = z.object({
	name: z.string().min(1, { message: REQUIRED }).trim(),
});

export type CreateCategory = z.infer<typeof CreateCategorySchema>;
